import NpawPlugin from 'npaw-plugin';

import { getNpawAdapterCAF } from './NpawAdapterCAF';
import { CAFAdapterOptions } from './utils';
import { getPlayerManager } from '../lib';

export function configureAdapters(
  plugin: NpawPlugin,
  options: CAFAdapterOptions,
) {
  plugin.registerAdapterFromClass(
    getPlayerManager(),
    getNpawAdapterCAF(options),
  );
}
